import Home from "../pages/home";
import RecycleBin from "../pages/recycle-bin";
import MaterialCenter from "../pages/material-center";
import CreateCenter from "../pages/create";
import DraftBox from "../pages/draftBox";
import SmartAuditing from "../pages/smartAuditing";
import ChannelAnalysis from "../pages/channelAnalysis";
import TagsAnalysis from "../pages/tagsAnalysis";
import EffectAnalysis from "../pages/EffectAnalysis";
import CustomizationReport from "../pages/customizationReport";
import ContentLibrary from "../pages/contentLibrary";
import PrivateDomain from "../pages/privateDomain";
import PublicDomain from "../pages/publicDomain";
import DistributionManagement from "../pages/distributionManagement";
// import OrganizationManage from "../pages/organizationManage";
// import UserMng from "../pages/userMng";
// import RoleMng from "../pages/roleMng";
// import MenuManage from "../pages/menuManage";
// import PrivilegeManage from "../pages/privilegeManage";
import CommunityGroup from "../pages/communityGroup";
import SensitiveWords from "../pages/sensitiveWords";
import Report from "../pages/report";
import UserManage from "../pages/userManage";
import RoleManage from "../pages/accountAuthorization";
import PermissionManage from "../pages/permissionManage";
import Login from "../login";
// import {
//   Offline,
//   Online,
//   CarData,
//   VehiclePositioning,
//   CarControl,
//   UserMap,
//   UserAction,
//   UserConversionRate,
//   UserGrowth,
//   Users,
//   VehicleDistribution,
//   TagManagement,
//   StrategyLibrary,
//   TagConnentData,
//   ProductRecord,
//   ContentRecommendationRecord,
//   PositioningStatistics,
//   VehicleService,
// } from "../pages2/all-pages";

import {
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  AppstoreAddOutlined,
  AuditOutlined,
  BranchesOutlined,
  CiOutlined,
  AreaChartOutlined,
  BarChartOutlined,
  DotChartOutlined,
  SlidersOutlined,
  // DribbbleOutlined,
  // IdcardOutlined,
  // SkinOutlined,
  TeamOutlined,
  BgColorsOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  // RadarChartOutlined,
  UserOutlined,
  WalletOutlined,
} from "@ant-design/icons";

// const Routes2 = [
//   {
//     path: "/data",
//     label: "数据仓库",
//     key: "data",
//     icon: <MailOutlined />,
//     children: [
//       {
//         path: "offline",
//         label: "线下数据",
//         icon: <DesktopOutlined />,
//         element: <Offline />,
//       },
//       {
//         path: "online",
//         label: "线上数据",
//         icon: <BgColorsOutlined />,
//         element: <Online />,
//       },
//     ],
//   },
//   {
//     path: "carData",
//     label: "车辆数据",
//     icon: <ContainerOutlined />,
//     element: <CarData />,
//   },
//   {
//     path: "vehiclePositioning",
//     label: "车辆定位",
//     icon: <RadarChartOutlined />,
//     element: <VehiclePositioning />,
//   },
//   {
//     path: "carControl",
//     label: "车控信息",
//     icon: <RadarChartOutlined />,
//     element: <CarControl />,
//   },
//   {
//     path: "userMap",
//     label: "用户旅程地图",
//     icon: <RadarChartOutlined />,
//     element: <UserMap />,
//   },
//   {
//     path: "userAction",
//     label: "用户行为",
//     element: <UserAction />,
//   },
//   {
//     path: "userConversionRate",
//     label: "用户转化率",
//     element: <UserConversionRate />,
//   },
//   {
//     path: "userGrowth",
//     label: "用户增长",
//     element: <UserGrowth />,
//   },
//   {
//     path: "users",
//     label: "用户信息",
//     element: <Users />,
//   },
//   {
//     path: "vehicleDistribution",
//     label: "车辆分布",
//     element: <VehicleDistribution />,
//   },
//   {
//     path: "tagManagement",
//     label: "标签库",
//     element: <TagManagement />,
//   },
//   {
//     path: "strategyLibrary",
//     label: "策略库",
//     element: <StrategyLibrary />,
//   },
//   {
//     path: "tagConnentData",
//     label: "标签关联数据",
//     element: <TagConnentData />,
//   },
//   {
//     path: "productRecord",
//     label: "商品推荐记录",
//     element: <ProductRecord />,
//   },
//   {
//     path: "contentRecommendationRecord",
//     label: "内容推荐记录",
//     element: <ContentRecommendationRecord />,
//   },
//   {
//     path: "positioningStatistics",
//     label: "定位统计",
//     element: <PositioningStatistics />,
//   },
//   {
//     path: "vehicleService",
//     label: "车辆服务",
//     element: <VehicleService />,
//   },
// ];

const Routes = [
  {
    path: "/",
    label: "登录",
    key: "login",
    element: <Login />,
  },
  {
    path: "homePage",
    label: "首页",
    key: "sub1",
    icon: <MailOutlined />,
    element: <Home />,
  },
  {
    path: "material",
    label: "素材管理",
    key: "sub2",
    icon: <ContainerOutlined />,
    children: [
      {
        path: "center",
        label: "素材中心",
        icon: <DesktopOutlined />,
        element: <MaterialCenter />,
      },
      {
        path: "recycleBin",
        label: "回收站",
        icon: <BgColorsOutlined />,
        element: <RecycleBin />,
      },
    ],
  },
  {
    path: "creation",
    label: "素材创作",
    icon: <MenuFoldOutlined />,
    children: [
      {
        path: "creationCenter",
        label: "创作中心",
        icon: <MenuUnfoldOutlined />,
        element: <CreateCenter />,
      },
      {
        path: "draftBox",
        label: "草稿箱",
        icon: <PieChartOutlined />,
        element: <DraftBox />,
      },
      {
        path: "smartAuditing",
        label: "智能审核",
        icon: <AppstoreOutlined />,
        element: <SmartAuditing />,
      },
    ],
  },
  {
    path: "assetManagement",
    label: "资产管理",
    icon: <AppstoreAddOutlined />,
    children: [
      {
        path: "contentLibrary",
        label: "作品内容库",
        icon: <AuditOutlined />,
        element: <ContentLibrary />,
      },
      {
        path: "privateDomain",
        label: "作品分发",
        icon: <ApartmentOutlined />,
        element: <PrivateDomain />,
      },
      {
        path: "publicDomain",
        label: "分发计划",
        icon: <BranchesOutlined />,
        element: <PublicDomain />,
      },
      {
        path: "distributionManagement",
        label: "分发管理",
        icon: <CiOutlined />,
        element: <DistributionManagement />,
      },
    ],
  },
  {
    path: "dataAnalysis",
    label: "数据分析",
    icon: <AreaChartOutlined />,
    children: [
      {
        path: "channelAnalysis",
        label: "渠道统计分析",
        icon: <PieChartOutlined />,
        element: <ChannelAnalysis />,
      },
      {
        path: "tagsAnalysis",
        label: "标签统计分析",
        icon: <BarChartOutlined />,
        element: <TagsAnalysis />,
      },
      {
        path: "effectAnalysis",
        label: "效果统计分析",
        icon: <DotChartOutlined />,
        element: <EffectAnalysis />,
      },
      {
        path: "customizationReport",
        label: "自定义报表",
        icon: <SlidersOutlined />,
        element: <CustomizationReport />,
      },
    ],
  },
  {
    path: "report",
    label: "举报管理",
    icon: <ContainerOutlined />,
    element: <Report />,
  },
  {
    path: "communityGroup",
    label: "圈子管理",
    icon: <SolutionOutlined />,
    element: <CommunityGroup />,
  },
  {
    path: "sensitiveWords",
    label: "敏感词管理",
    icon: <ContainerOutlined />,
    element: <SensitiveWords />,
  },
  {
    path: "user",
    label: "用户设置",
    children: [
      {
        path: "user",
        label: "用户管理",
        icon: <UserOutlined />,
        element: <UserManage />,
      },
      {
        path: "role",
        label: "角色管理",
        icon: <TeamOutlined />,
        element: <RoleManage />,
      },
      {
        path: "permission",
        label: "权限管理",
        icon: <WalletOutlined />,
        element: <PermissionManage />,
      },
    ],
  },
  // {
  //   path: "privilegeManage",
  //   label: "权限管理",
  //   icon: <SolutionOutlined />,
  //   element: <PrivilegeManage />,
  // },
  // {
  //   path: "menuManage",
  //   label: "菜单管理",
  //   icon: <DribbbleOutlined />,
  //   element: <MenuManage />,
  // },
  // {
  //   path: "roleMng",
  //   label: "角色管理",
  //   icon: <SkinOutlined />,
  //   element: <RoleMng />,
  // },
  // {
  //   path: "userMng",
  //   label: "用户管理",
  //   icon: <IdcardOutlined />,
  //   element: <UserMng />,
  // },
  // {
  //   path: "organizationManage",
  //   label: "用户组管理",
  //   icon: <TeamOutlined />,
  //   element: <OrganizationManage />,
  // },
];

export default Routes;
